import { Checkbox, Form, Radio } from 'antd';
import {
  avgSpendOptions,
  rewardStatusOptions,
  reviewStarsOptions,
  visitCountOptions,
  timePeriodOptions,
  birthdayMonthOptions,
} from './customerFilterConstant';
import { CAMPAIGN_GROUP_TYPE } from './customerFilterConstant';
import styled from 'styled-components';
import Box from '../../../../../components/Box';

const FilterOptions = ({ type, name }: { type: string; name: string }) => {
  const getOptions = () => {
    switch (type) {
      case CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN:
      case CAMPAIGN_GROUP_TYPE.VISITED_WITHIN:
        return timePeriodOptions.map((option) => ({
          label: option.label,
          value: option.value,
        }));
      case CAMPAIGN_GROUP_TYPE.REVIEW_GROUP:
        return reviewStarsOptions;
      case CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT:
        return visitCountOptions;
      case CAMPAIGN_GROUP_TYPE.AVG_VISIT:
        return avgSpendOptions;
      case CAMPAIGN_GROUP_TYPE.REWARD_GROUP:
        return rewardStatusOptions;
      case CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH:
        return birthdayMonthOptions;
      default:
        return [];
    }
  };

  const isRadioGroup = [
    CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN,
    CAMPAIGN_GROUP_TYPE.VISITED_WITHIN,
  ].includes(type as CAMPAIGN_GROUP_TYPE);

  const Component = isRadioGroup ? Radio.Group : Checkbox.Group;
  const options = getOptions().map((option) => ({
    label: option.label,
    value: `${type}_${option.value}`,
  }));

  return (
    <Container>
      <Box mb={1}>{type?.split('_').join(' ')}:</Box>
      <Form.Item
        name={name}
        rules={[{ required: true, message: 'Please select at least one option' }]}
        style={{ marginBottom: 0 }}
      >
        <Component style={{ width: '100%' }}>
          <GridBox>
            {options.map((option) =>
              isRadioGroup ? (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ) : (
                <Checkbox key={option.value} value={option.value}>
                  {option.label}
                </Checkbox>
              )
            )}
          </GridBox>
        </Component>
      </Form.Item>
    </Container>
  );
};

export default FilterOptions;

const GridBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`;

const Container = styled.div`
  background-color: #d4d7e4;
  border: 1px solid #d4d7e4;
  border-radius: 4px;
  padding: 1rem;
`;
